import { MINIMUM_DISCOUNT_TO_SHOW_PERCENTAGE_BADGE } from 'constants/content'

export interface DiscountPillVisibilityOptions {
  offerDiscountPillHidden: boolean
  shouldDisplayValue: boolean
  bundledWithFlightsOnly: boolean
  hasFlightPrice: boolean
  pricing: App.Pricing
  pricingWithFlights?: App.Pricing
  discountPercent?: number
  charterDisplayDiscountPercentage?: number
  hotelValueVisible: boolean
  flightsValueVisible: boolean
  charterValueVisible: boolean
}

export function getDiscountPillVisibilityFlags(options: DiscountPillVisibilityOptions) {
  const {
    offerDiscountPillHidden,
    shouldDisplayValue,
    bundledWithFlightsOnly,
    hasFlightPrice,
    pricing,
    pricingWithFlights,
    discountPercent,
    charterDisplayDiscountPercentage,
    hotelValueVisible,
    flightsValueVisible,
    charterValueVisible,
  } = options

  const hotelDiscountPercentVisible = (pricing.discountPercent ?? 0) >= MINIMUM_DISCOUNT_TO_SHOW_PERCENTAGE_BADGE
  const bundledDiscountPercentVisible = !!pricingWithFlights && (pricingWithFlights.discountPercent ?? 0) >= MINIMUM_DISCOUNT_TO_SHOW_PERCENTAGE_BADGE
  // The top "Save up to" pill is only eligible when the package has a
  // displayable hotel or bundled discount. Forced flight bundles also need a
  // priced flight before the discount can be advertised.
  const canShowTopDiscountPill = !offerDiscountPillHidden && (hotelDiscountPercentVisible || bundledDiscountPercentVisible) && shouldDisplayValue && (bundledWithFlightsOnly ? hasFlightPrice : true)
  const hotelValueDiscountPillVisible = canShowTopDiscountPill && hotelValueVisible && !!discountPercent
  const flightsValueDiscountPillVisible = canShowTopDiscountPill && flightsValueVisible && !!discountPercent
  const charterValueDiscountPillVisible = charterValueVisible && !offerDiscountPillHidden && (charterDisplayDiscountPercentage ?? 0) >= MINIMUM_DISCOUNT_TO_SHOW_PERCENTAGE_BADGE
  // Value-row discount pills sit next to an original value price, so they take
  // precedence over the standalone top pill. This avoids showing two discount
  // pills for the same package option.
  const valueDiscountPillVisible = charterValueDiscountPillVisible || hotelValueDiscountPillVisible || flightsValueDiscountPillVisible
  const topDiscountPillVisible = canShowTopDiscountPill && !valueDiscountPillVisible

  return {
    topDiscountPillVisible,
    hotelValueDiscountPillVisible,
    flightsValueDiscountPillVisible,
    charterValueDiscountPillVisible,
  }
}
